exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".L2BqKMWXpKLYx86I80hNx{font-weight:300;font-size:14px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] .L2BqKMWXpKLYx86I80hNx{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"header": "L2BqKMWXpKLYx86I80hNx"
};